// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { take, filter, map } from 'rxjs/operators';
import { MaybeLoadable, needsLoading, Loaded, Policy, Loadable, GoAction, QueueAlertAction, AlertType } from '@app/core';
import { selectPolicies, State, LoadingPolicyAction, RemovePolicyByIdAction } from './index';
import { SelectPolicyAction } from './policy-details/policy-details.actions';

const shouldLoadPolicies = (policies: MaybeLoadable) => needsLoading<Loaded<Policy[]>>(policies);
const hasPoliciesState = (policies: MaybeLoadable) => !needsLoading<Loaded<Policy[]>>(policies);

@Injectable({providedIn: 'root'})
export class PoliciesFacadeService {

    policies$: Observable<Loaded<Policy[]> | Loadable> = of();

    constructor(private store: Store<State>) {}

    initialize () {
        const maybePolicies$ = this.store.pipe(select(selectPolicies));

        maybePolicies$.pipe(take(1), filter(shouldLoadPolicies))
          .subscribe(() => this.store.dispatch(new LoadingPolicyAction()));

        this.policies$ = maybePolicies$.pipe(filter<Loaded<Policy[]> | Loadable>(hasPoliciesState));
    }

    selectPolicy(row: any) {
        this.store.dispatch(new SelectPolicyAction(row));
        this.store.dispatch(new GoAction(['/iam/policies/', row.id, 'edit']));
    }

    removePolicy(policyId: string) {
        this.store.dispatch(new RemovePolicyByIdAction(policyId));
        this.store.dispatch(new QueueAlertAction({
            alertText: `Policy delete succeed.`, alertType: AlertType.SUCCESS }));
    }

    failedRemovePolicy() {
        this.store.dispatch(new QueueAlertAction({ alertText: `Policy delete failed.`, alertType: AlertType.ERROR }));
    }

}




// WEBPACK FOOTER //
// ./src/app/access-management/state/policies.facade.ts